import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PrimeNG } from 'primeng/config';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { UnitService } from './core/services/unit.service';
import { ToastModule } from "primeng/toast";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ThemeService } from './core/services/theme-service.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, DynamicDialogModule, ToastModule, ConfirmDialogModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {

  private primeng = inject(PrimeNG);
  private unitService = inject(UnitService);
  private theme = inject(ThemeService);
  ngOnInit() {
    this.primeng.ripple.set(true);
    this.unitService.onStateChange(); 
 }
}
